import ConfirmButton from './ConfirmButton'

export default ConfirmButton
